<div class="modal-content">
	<div class="modal-header">
		<h4 class="modal-title fw-bold"> {{ 'study-editor.experiment.design.edit-treatment-factors' | translate }} </h4>
		<button type="button" class="btn-close" (click)="cancel()"></button>
	</div>
    <div class="modal-body">
		<div class="row pt-3 table-responsive">
			<div class="custom-scroll-style" style="max-height: 450px; overflow-y: auto; overflow-x: auto;">
			<table class="table table-striped table-curved" *ngFor="let key of Array.from(this.sortedInstancesMap.keys())">
				<thead>
					<tr>
						<th>
							<span translate="study-editor.experiment.design.edit-treatment-factors.trial-instance"></span>
						</th>
						<th>
							<span translate="study-editor.experiment.design.edit-treatment-factors.location-name"></span>
						</th>
						<th>
							<span>{{treatmentFactorsData[key].alias}}</span></th>
						<th>
							<span>{{treatmentFactorsData[key].labelAlias}}</span>
						</th>
						<th>
							<span translate="study-editor.experiment.design.edit-treatment-factors.actions"></span>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let row of Array.from(this.sortedInstancesMap.get(key))">
						<td>
							<span>{{row.instanceNumber}}</span>
						</td>
						<td>
							<span>{{row.locationName}}</span>
						</td>
						<td>
							<span>{{row.idx}}</span>
						</td>
						<td>
							<span>{{row.labelCategorical ? row.categoryName : row.label}}</span>
						</td>
						<td>
							<button *ngIf="!disableDeleteButton(row.instanceNumber, key); else disableDeleteInfo" class="btn btn-outline-info btn-sm me-2"
								(click)="excludeCombination(row, key)">
								<i class="fa fa-trash fa-md" aria-hidden="true"></i>
							</button>
							<ng-template #disableDeleteInfo>
								<i class="fa fa-info-circle fa-md" [ngbTooltip]="disabledDeleteMessage"></i>
							</ng-template>
						</td>
					</tr>
				</tbody>
			</table>
			</div>
		</div>
        <div class="row pt-3">
			<jhi-collapsible customClass="d-inline-flex p-2 h5 fw-bold" heading="{{'study-editor.experiment.design.edit-treatment-factors.summary' | translate}}" [isCollapsed]="hideSummary">
				<div class="row mb-2">
					<div class="col-4">
						<div class="card bg-white">
							<div class="card-body">
								<div class="row mb-2">
									<div class="col">
										<span translate="study-editor.experiment-design.edit-treatment-factors.germplasm.no"></span>
									</div>
									<div class="col">
										<span class="value-chip">{{totalGermplasmEntryListCount || '-'}}</span>
									</div>
								</div>
								<div class="row mb-2">
									<div class="col">
										<span translate="study-editor.experiment-design.edit-treatment-factors.reps.no"></span>
									</div>
									<div class="col">
										<span class="value-chip">{{experimentDesignInput.replicationsCount || '-'}}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-8 table-responsive">
						<div class="custom-scroll-style" style="max-height: 200px; overflow-y: auto; overflow-x: auto;">
						<table class="table table-striped table-curved">
							<thead>
							<tr>
								<th>
									<span translate="study-editor.experiment.design.edit-treatment-factors.trial-instance"></span>
								</th>
								<th>
									<span translate="study-editor.experiment.design.edit-treatment-factors.location-name"></span>
								</th>
								<th>
									<span translate="study-editor.experiment.design.edit-treatment-factors.treatment"></span>
								</th>
								<th>
									<span translate="study-editor.experiment.design.edit-treatment-factors.no.of.levels"></span>
								</th>
								<th>
									<span translate="study-editor.experiment-design.edit-treatment-factors.plots.no"></span>
								</th>
							</tr>
							</thead>
							<tbody>
								<ng-container *ngFor="let treatmentFactorInstance of Array.from(this.summaryMap.keys())">
									<tr *ngFor="let row of Array.from(this.summaryMap.get(treatmentFactorInstance).values())">
										<td>
											<span>{{row.instanceNumber}}</span>
										</td>
										<td>
											<span>{{row.locationName}}</span>
										</td>
										<td>
											<span>{{row.alias}}</span>
										</td>
										<td>
											<span>{{row.levelCount}}</span>
										</td>
										<td>
											<span>{{this.plotCountPerInstance.get(row.instanceNumber)}}</span>
										</td>
									</tr>
								</ng-container>
							</tbody>
						</table>
						</div>
					</div>
				</div>
			</jhi-collapsible>
        </div>
        <div class="container-fluid px-0 pt-3">
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="cancel()" [disabled]="isSaving">
            <span translate="back"></span>
        </button>
        <button (click)="continue()" class="btn btn-primary" [disabled]="isSaving || getSelectedInstanceIds().length === 0">
            <i *ngIf="isSaving" class="throbber throbber-btn"></i>
            <span class="ms-1" translate="continue"></span>
        </button>
    </div>
</div>
